import { render, staticRenderFns } from "./UserCreateForm.vue?vue&type=template&id=4c71428c&scoped=true"
import script from "./UserCreateForm.vue?vue&type=script&lang=js"
export * from "./UserCreateForm.vue?vue&type=script&lang=js"
import style0 from "./UserCreateForm.vue?vue&type=style&index=0&id=4c71428c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71428c",
  null
  
)

export default component.exports